import useAlert from "@rf-hooks/useAlert";
import { useSendActivationRequestMutation } from "@/src-refactor/modules/store/qrtk/services/realestate/realestate.qrtk";

type HandleArgs = {
  realEstateId: string | number;
};

const useActivationRequest = () => {
  const { warningAlert, successAlert, errorAlert } = useAlert();
  const [sendActivationRequest, { isLoading }] = useSendActivationRequestMutation();

  const handleSentActivationRequest = async ({ realEstateId }: HandleArgs) => {
    const res = await warningAlert({
      title: "Solicitar reactivación",
      message:
        "Se enviará un correo al equipo de propiedades para solicitar la reactivación. ¿Deseas continuar?",
      confirmBtnMessage: "Enviar solicitud",
      declineBtnMessage: "Cancelar"
    });

    if (!res?.type?.confirm) return;

    try {
      await sendActivationRequest({ params: { id: realEstateId } }).unwrap();
      await successAlert({
        title: "Solicitud enviada",
        message: "Hemos notificado al equipo de propiedades."
      });
    } catch (e: any) {
      await errorAlert({
        title: "No se pudo enviar",
        message: "Inténtalo de nuevo más tarde."
      });
    }
  };

  return { handleSentActivationRequest, isLoading };
};

export default useActivationRequest;

